// Mock Data for SparkCommerce

export const mockUser = {
  id: 'usr_1',
  name: 'kathir',
  email: 'kathir@VirtualSpark info tech.com',
  avatar: null,
  role: 'owner',
};

export const mockOrganizations = [
  { id: 'org_1', name: 'TechStore India', slug: 'techstore-india', plan: 'pro' },
  { id: 'org_2', name: 'Fashion Hub', slug: 'fashion-hub', plan: 'free' },
];

export const mockProducts = [
  { id: 'prod_1', name: 'iPhone 15 Pro', sku: 'IPH15PRO', price: 134900, cost: 120000, stock: 25, category: 'Electronics', image: 'https://images.unsplash.com/photo-1695048133142-1a20484d2569?w=200', status: 'active' },
  { id: 'prod_2', name: 'Samsung Galaxy S24', sku: 'SGS24', price: 79999, cost: 65000, stock: 42, category: 'Electronics', image: 'https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?w=200', status: 'active' },
  { id: 'prod_3', name: 'MacBook Air M3', sku: 'MBAM3', price: 114900, cost: 95000, stock: 15, category: 'Laptops', image: 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=200', status: 'active' },
  { id: 'prod_4', name: 'AirPods Pro 2', sku: 'APP2', price: 24900, cost: 18000, stock: 67, category: 'Accessories', image: 'https://images.unsplash.com/photo-1600294037681-c80b4cb5b434?w=200', status: 'active' },
  { id: 'prod_5', name: 'Sony WH-1000XM5', sku: 'SWXM5', price: 29990, cost: 22000, stock: 3, category: 'Accessories', image: 'https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?w=200', status: 'low_stock' },
  { id: 'prod_6', name: 'iPad Pro 12.9"', sku: 'IPDP12', price: 112900, cost: 95000, stock: 8, category: 'Tablets', image: 'https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=200', status: 'active' },
  { id: 'prod_7', name: 'Apple Watch Ultra 2', sku: 'AWU2', price: 89900, cost: 75000, stock: 12, category: 'Wearables', image: 'https://images.unsplash.com/photo-1434494878577-86c23bcb06b9?w=200', status: 'active' },
  { id: 'prod_8', name: 'Dell XPS 15', sku: 'DXPS15', price: 159900, cost: 135000, stock: 0, category: 'Laptops', image: 'https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?w=200', status: 'out_of_stock' },
];

export const mockCategories = [
  { id: 'cat_1', name: 'Electronics', productCount: 45 },
  { id: 'cat_2', name: 'Laptops', productCount: 23 },
  { id: 'cat_3', name: 'Accessories', productCount: 67 },
  { id: 'cat_4', name: 'Tablets', productCount: 12 },
  { id: 'cat_5', name: 'Wearables', productCount: 18 },
];

export const mockCustomers = [
  { id: 'cust_1', name: 'Rahul Sharma', phone: '+91 98765 43210', email: 'rahul@gmail.com', orders: 12, totalSpent: 245600, lastOrder: '2024-12-15', tags: ['VIP', 'Repeat'] },
  { id: 'cust_2', name: 'Priya Patel', phone: '+91 87654 32109', email: 'priya@gmail.com', orders: 5, totalSpent: 89400, lastOrder: '2024-12-10', tags: ['New'] },
  { id: 'cust_3', name: 'Amit Kumar', phone: '+91 76543 21098', email: 'amit@gmail.com', orders: 23, totalSpent: 567800, lastOrder: '2024-12-18', tags: ['VIP', 'Wholesale'] },
  { id: 'cust_4', name: 'Sneha Gupta', phone: '+91 65432 10987', email: 'sneha@gmail.com', orders: 8, totalSpent: 156700, lastOrder: '2024-12-12', tags: ['Repeat'] },
  { id: 'cust_5', name: 'Vikram Singh', phone: '+91 54321 09876', email: 'vikram@gmail.com', orders: 3, totalSpent: 45600, lastOrder: '2024-12-08', tags: ['New'] },
];

export const mockOrders = [
  { id: 'ORD-001', customer: 'Rahul Sharma', items: 3, amount: 164700, status: 'completed', date: '2024-12-18', paymentMethod: 'UPI' },
  { id: 'ORD-002', customer: 'Priya Patel', items: 1, amount: 24900, status: 'processing', date: '2024-12-18', paymentMethod: 'Card' },
  { id: 'ORD-003', customer: 'Amit Kumar', items: 5, amount: 289600, status: 'completed', date: '2024-12-17', paymentMethod: 'Bank Transfer' },
  { id: 'ORD-004', customer: 'Sneha Gupta', items: 2, amount: 54880, status: 'pending', date: '2024-12-17', paymentMethod: 'Cash' },
  { id: 'ORD-005', customer: 'Vikram Singh', items: 1, amount: 79999, status: 'cancelled', date: '2024-12-16', paymentMethod: 'UPI' },
  { id: 'ORD-006', customer: 'Rahul Sharma', items: 2, amount: 139800, status: 'completed', date: '2024-12-15', paymentMethod: 'Card' },
];

export const mockInvoices = [
  { id: 'INV-001', customer: 'Rahul Sharma', amount: 164700, status: 'paid', date: '2024-12-18', dueDate: '2024-12-25' },
  { id: 'INV-002', customer: 'Priya Patel', amount: 24900, status: 'pending', date: '2024-12-18', dueDate: '2024-12-25' },
  { id: 'INV-003', customer: 'Amit Kumar', amount: 289600, status: 'paid', date: '2024-12-17', dueDate: '2024-12-24' },
  { id: 'INV-004', customer: 'Sneha Gupta', amount: 54880, status: 'overdue', date: '2024-12-10', dueDate: '2024-12-15' },
  { id: 'INV-005', customer: 'Vikram Singh', amount: 79999, status: 'cancelled', date: '2024-12-16', dueDate: '2024-12-23' },
];

export const mockPayments = [
  { id: 'PAY-001', customer: 'Rahul Sharma', amount: 164700, method: 'UPI', date: '2024-12-18', status: 'completed' },
  { id: 'PAY-002', customer: 'Amit Kumar', amount: 289600, method: 'Bank Transfer', date: '2024-12-17', status: 'completed' },
  { id: 'PAY-003', customer: 'Sneha Gupta', amount: 30000, method: 'Cash', date: '2024-12-17', status: 'partial' },
  { id: 'PAY-004', customer: 'Rahul Sharma', amount: 139800, method: 'Card', date: '2024-12-15', status: 'completed' },
];

export const mockConversations = [
  {
    id: 'conv_1',
    customer: { id: 'cust_1', name: 'Rahul Sharma', phone: '+91 98765 43210', avatar: null },
    lastMessage: 'Thanks! I received the order.',
    timestamp: new Date(Date.now() - 5 * 60000).toISOString(),
    unread: 0,
    mode: 'ai',
  },
  {
    id: 'conv_2',
    customer: { id: 'cust_2', name: 'Priya Patel', phone: '+91 87654 32109', avatar: null },
    lastMessage: 'What is the price of iPhone 15?',
    timestamp: new Date(Date.now() - 15 * 60000).toISOString(),
    unread: 2,
    mode: 'ai',
  },
  {
    id: 'conv_3',
    customer: { id: 'cust_3', name: 'Amit Kumar', phone: '+91 76543 21098', avatar: null },
    lastMessage: 'I want to place a bulk order',
    timestamp: new Date(Date.now() - 30 * 60000).toISOString(),
    unread: 1,
    mode: 'manual',
  },
  {
    id: 'conv_4',
    customer: { id: 'cust_4', name: 'Sneha Gupta', phone: '+91 65432 10987', avatar: null },
    lastMessage: 'Can you share the invoice?',
    timestamp: new Date(Date.now() - 60 * 60000).toISOString(),
    unread: 0,
    mode: 'ai',
  },
  {
    id: 'conv_5',
    customer: { id: 'cust_5', name: 'Vikram Singh', phone: '+91 54321 09876', avatar: null },
    lastMessage: 'Is MacBook Air available?',
    timestamp: new Date(Date.now() - 120 * 60000).toISOString(),
    unread: 3,
    mode: 'ai',
  },
];

export const mockMessages = {
  conv_1: [
    { id: 'm1', content: 'Hi, I want to know the status of my order', sender: 'customer', timestamp: new Date(Date.now() - 60 * 60000).toISOString() },
    { id: 'm2', content: 'Hello Rahul! Your order ORD-001 has been shipped and will arrive by tomorrow. Here is your tracking link: track.delivery/ORD001', sender: 'ai', timestamp: new Date(Date.now() - 55 * 60000).toISOString() },
    { id: 'm3', content: 'Great, thanks!', sender: 'customer', timestamp: new Date(Date.now() - 50 * 60000).toISOString() },
    { id: 'm4', content: 'You\'re welcome! Let me know if you need anything else.', sender: 'ai', timestamp: new Date(Date.now() - 45 * 60000).toISOString() },
    { id: 'm5', content: 'Thanks! I received the order.', sender: 'customer', timestamp: new Date(Date.now() - 5 * 60000).toISOString() },
  ],
  conv_2: [
    { id: 'm1', content: 'Hello', sender: 'customer', timestamp: new Date(Date.now() - 20 * 60000).toISOString() },
    { id: 'm2', content: 'Hi Priya! Welcome to TechStore. How can I help you today?', sender: 'ai', timestamp: new Date(Date.now() - 18 * 60000).toISOString() },
    { id: 'm3', content: 'What is the price of iPhone 15?', sender: 'customer', timestamp: new Date(Date.now() - 15 * 60000).toISOString() },
  ],
  conv_3: [
    { id: 'm1', content: 'Hi, I want to place a bulk order for my company', sender: 'customer', timestamp: new Date(Date.now() - 35 * 60000).toISOString() },
    { id: 'm2', content: 'Hello Amit! Thank you for your interest. I\'m connecting you with our sales team for bulk orders.', sender: 'ai', timestamp: new Date(Date.now() - 33 * 60000).toISOString() },
    { id: 'm3', content: 'I want to place a bulk order', sender: 'customer', timestamp: new Date(Date.now() - 30 * 60000).toISOString() },
  ],
};

export const mockDashboardStats = {
  revenue: { value: 1245600, change: 12.5, period: 'today' },
  orders: { value: 47, change: 8.2, period: 'today' },
  aiReplies: { value: 234, change: 15.3, period: 'today' },
  customers: { value: 12, change: -2.1, period: 'new today' },
};

export const mockChartData = {
  revenue: [
    { date: 'Mon', revenue: 125000, orders: 12 },
    { date: 'Tue', revenue: 189000, orders: 18 },
    { date: 'Wed', revenue: 156000, orders: 15 },
    { date: 'Thu', revenue: 234000, orders: 22 },
    { date: 'Fri', revenue: 198000, orders: 19 },
    { date: 'Sat', revenue: 278000, orders: 28 },
    { date: 'Sun', revenue: 145000, orders: 14 },
  ],
  ordersByStatus: [
    { name: 'Completed', value: 65 },
    { name: 'Processing', value: 20 },
    { name: 'Pending', value: 10 },
    { name: 'Cancelled', value: 5 },
  ],
};

export const mockNotifications = [
  { id: 'n1', title: 'New Order', message: 'Rahul Sharma placed an order for ₹164,700', time: '5 min ago', read: false },
  { id: 'n2', title: 'Low Stock Alert', message: 'Sony WH-1000XM5 has only 3 units left', time: '15 min ago', read: false },
  { id: 'n3', title: 'Payment Received', message: 'Payment of ₹289,600 received from Amit Kumar', time: '1 hour ago', read: true },
  { id: 'n4', title: 'New Customer', message: 'Vikram Singh signed up via WhatsApp', time: '2 hours ago', read: true },
];

export const mockTeamMembers = [
  { id: 'tm_1', name: 'kathir', email: 'kathir@VirtualSpark info tech.com', role: 'Owner', status: 'active' },
  { id: 'tm_2', name: 'Jane Smith', email: 'jane@VirtualSpark info tech.com', role: 'Admin', status: 'active' },
  { id: 'tm_3', name: 'Bob Wilson', email: 'bob@VirtualSpark info tech.com', role: 'Staff', status: 'active' },
  { id: 'tm_4', name: 'Alice Brown', email: 'alice@VirtualSpark info tech.com', role: 'Staff', status: 'invited' },
];

export const mockPricingPlans = [
  {
    id: 'free',
    name: 'Free',
    price: 0,
    description: 'For small businesses getting started',
    features: ['100 AI replies/month', '1 staff member', '1 WhatsApp number', 'Basic reports', 'Email support'],
    cta: 'Start Free',
    popular: false,
  },
  {
    id: 'pro',
    name: 'Pro',
    price: 2999,
    description: 'For growing businesses',
    features: ['5,000 AI replies/month', '5 staff members', '2 WhatsApp numbers', 'Advanced reports', 'Priority support', 'Custom AI training', 'API access'],
    cta: 'Start Trial',
    popular: true,
  },
  {
    id: 'business',
    name: 'Business',
    price: 9999,
    description: 'For large teams & enterprises',
    features: ['Unlimited AI replies', 'Unlimited staff', '10 WhatsApp numbers', 'Custom reports', 'Dedicated support', 'White-label options', 'SLA guarantee', 'Custom integrations'],
    cta: 'Contact Sales',
    popular: false,
  },
];

export const mockAutomations = [
  { id: 'auto_1', name: 'Welcome Message', trigger: 'New customer', status: 'active', runs: 234 },
  { id: 'auto_2', name: 'Order Confirmation', trigger: 'Order placed', status: 'active', runs: 567 },
  { id: 'auto_3', name: 'Abandoned Cart', trigger: 'Cart abandoned 1hr', status: 'active', runs: 89 },
  { id: 'auto_4', name: 'Review Request', trigger: 'Order delivered', status: 'paused', runs: 156 },
  { id: 'auto_5', name: 'Low Stock Alert', trigger: 'Stock < 10', status: 'active', runs: 23 },
];
